export default __webpack_public_path__ + "static/media/noa-13.70f9e963.jpg";